<template>
	<div class="chat-container w-100 position-relative bg-light-page"  v-if="isCart">
    <div class=" position-relative">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom z-index-1029 d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white pb-3">
                  <div class="w-100 px-4">
                  	<router-link :to="'/'+getMerchant().code+'/concierge/experience/'+merchant_child_id+'/cart'">
	                    <div class="bg-green box-shadow-1 py-2 px-4 radius-12 box-shadow-bottom-nav">
	                    	<div class="row">
	                    		<div class="col-4">
	                    			<img src="../../../../assets/img/icon/cart.png" width="23" class="my-2">
	                    		</div>
	                    		<div class="col-8">
	                    			<p class="text-white text-right mb-0 body-2-4">{{CartItemQty}} Ticket</p>
	                    			<p class="text-white text-right mb-0 text-16 font-bold">{{formatCurrency(total_price)}}</p>
	                    		</div>
	                    	</div>
	                    </div>
	                  </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import {mapGetters} from "vuex";
  import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'

  export default{
  	data(){
  		return{
  			isCart : false,
  		}
  	},
  	mounted(){
  		this.checkCart();
  	},
  	computed:{            
    	CartItemQty(){		
				let total = 0
        for(let data of this.getConciergeOrder().experience.cart){
          total += data.qty
        }
        return total
			},
      merchant_child_id(){
        return this.$route.params.id
      },
      total_price(){
        let total = 0
        for(let cart of this.getConciergeOrder().experience.cart){
          if(cart.product.is_variant){
            for(let variant of cart.variant){
              total += calculateFinalPriceConcierge(variant.data.price) * variant.qty
            }
          }else{
            total += calculateFinalPriceConcierge(cart.product.data.price) * cart.qty
          }
        }

        return total
      }
    },
    watch: {
			CartItemQty(){		
        this.checkCart()
      }
    },
    methods:{
    	...mapGetters(['getConciergeOrder','getMerchant']),
    	formatCurrency(value){
        return formatCurrency(value);
      },
      checkCart(){
      	this.isCart = false;                             
        if(this.CartItemQty>0){
          this.isCart = true;
        }
        else {
          this.isCart = false;
        } 
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/floatingCartExperience.vue